import i18n from '@/plugins/i18n';
export const forms = [
    {
        type: 'select',
        name: 'beginDay',
        title: i18n.t('account.workHours.beginDay'),
        rules: {required: true},
        options: {
            type: 'locale',
            data:[
                { name: i18n.t('general.days.mon'), id: 1 },
                { name: i18n.t('general.days.tue'), id: 2 },
                { name: i18n.t('general.days.wed'), id: 3 },
                { name: i18n.t('general.days.thu'), id: 4 },
                { name: i18n.t('general.days.fri'), id: 5 },
                { name: i18n.t('general.days.sat'), id: 6 },
                { name: i18n.t('general.days.sun'), id: 7 },
            ],
            track: 'id',
            label: 'name'
        },
        modal: ['begin_day_id'],
        data: ['begin_day_id',],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'select',
        name: 'endDay',
        title: i18n.t('account.workHours.endDay'),
        rules: {required: true},
        options: {
            type: 'locale',
            data:[
                { name: i18n.t('general.days.mon'), id: 1 },
                { name: i18n.t('general.days.tue'), id: 2 },
                { name: i18n.t('general.days.wed'), id: 3 },
                { name: i18n.t('general.days.thu'), id: 4 },
                { name: i18n.t('general.days.fri'), id: 5 },
                { name: i18n.t('general.days.sat'), id: 6 },
                { name: i18n.t('general.days.sun'), id: 7 },
            ],
            track: 'id',
            label: 'name'
        },
        modal: ['end_day_id'],
        data: ['end_day_id',],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'time',
        name: 'openTime',
        title: i18n.t('account.workHours.openingTime'),
        format:"HH:mm:ss",
        rules: {required: true},
        modal: ['opening_time'],
        data: ['opening_time'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'time',
        name: 'endTime',
        title: i18n.t('account.workHours.closingTime'),
        format:"HH:mm:ss",
        rules: {required: true},
        modal: ['closing_time'],
        data: ['closing_time'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'radio',
        name: 'isClose',
        title: i18n.t('account.workHours.offDay'),
        options:{
            type: 'locale',
            default:false,
            data:[
                { text: i18n.t('general.yes'), value: true },
                { text: i18n.t('general.no'), value: false },
            ],
            track: 'value',
            label: 'text'
        },
        rules: {required: true},
        modal: ['is_close'],
        data: ['is_close'],
        additionalButton: false,
        checkBox: false
    },
    
 
]
export default forms;


// WEBPACK FOOTER //
// ./src/pages/Alarmsis/Account/forms/workhours.js